import React from "react";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Button,
  IconButton,
  Avatar,
  InputBase,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Stack,
  Chip,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { styled } from "@mui/material/styles";
import { StyledCellHeader } from "../../../../components/StyledCellHeader";
import { RemoveRedEyeOutlined, Payment, TrendingUp, Assessment, AccountBalance } from "@mui/icons-material";
import CrearProveedorDialog from "../proveedores/crearproveedordialog";
import { fetchProveedores } from "../../../../utils/generalsFetch";
import { useNavigate } from "react-router-dom";
import StatusChip from "../../../../components/StatusChip";
import AccessDeniedBox from '../../../../components/AccessDeniedBox';
import EmptyState from '../../../../components/EmptyState';

const SearchPaper = styled(Paper)(({ theme }) => ({
  padding: "2px 8px",
  display: "flex",
  alignItems: "center",
  background: "#f0f2f4",
  minWidth: 200,
  maxWidth: 300,
  borderRadius: "8px",
  boxShadow: "none",
}));

export default function PagosProveedores() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage] = React.useState(8);
  const [search, setSearch] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [proveedores, setProveedores] = React.useState([]);
  const navigate = useNavigate();
  const [pagos, setPagos] = React.useState([]);
  const [accessDenied, setAccessDenied] = React.useState(false);
  React.useEffect(() => {
    fetchProveedores({ usuarioId: localStorage.getItem('id'), idcompany: localStorage.getItem('idcompany') }).then((data) => {
      setProveedores(data);
    }).catch((error) => {
      setAccessDenied(true);
    });
    fetchPagos();
  
  }, []);

  async function fetchPagos(){
    const response = await fetch(process.env.REACT_APP_SERVER_URL+`/api/pagos-compra/${localStorage.getItem('idcompany')}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Usuario-ID': localStorage.getItem('id'),
          'X-company-ID': localStorage.getItem('idcompany'),
      },
    });
    const data = await response.json();
    setPagos(data);
  }

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const filtered = pagos.filter((row) =>
    Object.values(row)
      .join(" ")
      .toLowerCase()
      .includes(search.toLowerCase())
  );
  return (
    <Box sx={{ fontFamily: "Inter, Noto Sans, sans-serif", bgcolor: "#fff", minHeight: "100vh" }}>
      {!accessDenied ? 
      <Box >
        <Box display="flex" justifyContent="end" mb={2}>
          <Button
            variant="contained"
            color="primarybutton"
            startIcon={<AddIcon />}
            sx={{
              fontWeight: "bold",
              fontSize: 15,
              boxShadow: "none",
              minWidth: 120,
            }}                  
            onClick={()=>{navigate('/logistica/compras/pagos/agregar')}}
          >
            Agregar Pago
          </Button>
        </Box>

            
        {/* Show empty state if no payments */}
        {pagos.length === 0 ? (
            <EmptyState 
                icon={Payment}
                title="No hay pagos registrados"
                description="Comienza registrando tu primer pago a proveedores para mantener un control completo de las obligaciones financieras y el flujo de efectivo."
                features={[
                    {
                        icon: AccountBalance,
                        title: "Control Financiero",
                        description: "Gestión completa de pagos y obligaciones"
                    },
                    {
                        icon: TrendingUp,
                        title: "Seguimiento de Pagos",
                        description: "Monitoreo de montos y métodos de pago"
                    },
                    {
                        icon: Assessment,
                        title: "Reportes de Pagos",
                        description: "Análisis de flujo de efectivo y gastos"
                    }
                ]}
                buttonText="Registrar Primer Pago"
                onButtonClick={() => navigate('/logistica/compras/pagos/agregar')}
                helpText="¿Necesitas ayuda? Contacta a soporte técnico para guiarte en el proceso"
            />
        ) : (
            <>
            {/* Table */}
            <TableContainer component={Paper} sx={{ borderRadius: 3, boxShadow: "none", minHeight: "500px" }}>
              <Table>
                <TableHead>
                  <TableRow sx={{ bgcolor: "#fff" }}>
                    <StyledCellHeader align="center"># Factura</StyledCellHeader>
                    <StyledCellHeader>Proveedor</StyledCellHeader>
                    <StyledCellHeader>Monto</StyledCellHeader>
                    <StyledCellHeader>Metodo de Pago</StyledCellHeader>
                    <StyledCellHeader>Creacion</StyledCellHeader>
                    <StyledCellHeader align="center"></StyledCellHeader>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filtered
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row, idx) => (
                      <TableRow key={idx} hover>
                        <TableCell align="center">{row.numero_factura}</TableCell>
                        <TableCell>{row.proveedor_name}</TableCell>
                        <TableCell>{row.monto_pagado}</TableCell>
                        <TableCell>{row.metodo_pago}</TableCell>
                        <TableCell>{row.fecha_pago}</TableCell>
                        <TableCell align="center">
                          <IconButton size="small" sx={{ color: "#617689" }} onClick={()=>{navigate(`/logistica/compras/pagos/${row.id}`)}}>
                            <RemoveRedEyeOutlined/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            {/* Pagination */}
            <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
              <TablePagination
                component="div"
                count={filtered.length}
                page={page}
                onPageChange={handleChangePage}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={[8]}
                labelRowsPerPage=""
              />
            </Box>
            </>
        )}

      </Box>
      :
      <Box>
        <br></br>
        <br></br>
        <AccessDeniedBox
          title={'Acceso denegado'}
          message={'No tienes permisos para ver esta sección de Pagos de Proveedores. Contacta a tu administrador para solicitar acceso o verifica tus roles y permisos.'}
        />
      </Box>
      }
    </Box>
  );
};

